import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.css";

interface Props {
  onClick: () => void;
}

export const DeliveryLabel = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <button type="button" className={styles.delivery_link} onClick={onClick}>
      <span>{t("lbl_contract_details_delivery_title")}</span>
      <InfoOutlinedIcon className={styles.delivery_info_icon} />
    </button>
  );
};
